import { api } from "@/lib/api";

const CHUNK = 8 * 1024 * 1024;

export async function uploadFile({ projectId, file, name, type, kind, onInit, onProgress }) {
  const { data: asset } = await api.post("/assets/upload/init", { project_id: projectId, filename: name, size: file.size, content_type: type, kind });
  onInit?.(asset);
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    await api.put(`/assets/${asset.id}/chunk?index=${i}`, file.slice(i * CHUNK, (i + 1) * CHUNK), { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(asset.id, Math.round(((i + 1) / total) * 100));
  }
  return (await api.post(`/assets/${asset.id}/complete`)).data;
}

export async function waitReady(id, timeoutMs = 300000) {
  const end = Date.now() + timeoutMs;
  while (Date.now() < end) {
    const { data } = await api.get(`/assets/${id}`);
    if (data.status === "ready") return data;
    if (data.status === "failed") throw new Error(data.error || "Processing failed");
    await new Promise((r) => setTimeout(r, 2000));
  }
  throw new Error("Timed out waiting for upload");
}
